import Web3 from "web3";
import Torus from "@toruslabs/torus-embed";
import config from "../config.js";
import axios from "axios";
import ga from "../ga";

const web3Provider = window.ethereum;
const KingdomLandSale = config.abi.sale;

export const ERC20_ABI = [{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"supply","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"digits","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"balance","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"remaining","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_owner","type":"address"},{"indexed":true,"name":"_spender","type":"address"},{"indexed":false,"name":"_value","type":"uint256"}],"name":"Approval","type":"event"}];
export var contract;
export var web3;

export const ETH = (value) => {
    return Number(web3.utils.fromWei(value.toString(), "ether"));
}

export const WEI = (value) => {
    value = value.toString().substr(0, 16)
    return web3.utils.toWei(value, "ether");
}

export const connectWallet = async (store, wallet) => {
    let account = null;
    if (wallet == null) {
        wallet = localStorage.getItem('wallet');
    }

    if (wallet == "metamask") {
        web3 = new Web3(web3Provider);

        const accounts = await window.ethereum.enable();
        web3 = new Web3(window.ethereum);
        console.log(accounts);
        account = { address: accounts[0], balance: 0 };
    } else if (wallet == "dappcom") {
        console.log("DAPPCONNECTED");
        await window.loadScript("lib/DappStoreWallet-Ethereum");
        await window.loadScript("lib/web3.min");
        window.dappstore = new window.DappStoreWallet(
            "d03db299-0231-49bf-95d6-5b4c6f898167"
        );
        web3 = new Web3(window.dappstore.provider);
        console.log("DAPPCONNECTED");
        account = {
            address: web3.eth.accounts.currentProvider.selectedAddress,
            balance: 0
        };
    } else if (wallet == "torus") {
        const torus = new Torus();
        await torus.init({
            network: {
                host: config.eth.networks[config.eth.net]
            }
        });
        await torus.ethereum.enable();
        web3 = new Web3(torus.provider);
        console.log(web3.eth.accounts.currentProvider.selectedAddress);
        account = {
            address: web3.eth.accounts.currentProvider.selectedAddress,
            balance: 0
        };
    }
    if (account != null) {
        contract = new web3.eth.Contract(
            KingdomLandSale.abi,
            KingdomLandSale.networks[config.eth.net].address
        );

        localStorage.setItem('wallet', wallet);
        store.commit('setAccount', { wallet: wallet, account: account });

        var ret = await axios.post(
            `${config.api.nft_url}/landlord/info`,
            {
                address: account.address
            }
          );
        if (ret.data.result) {
            store.commit('setLandLord', { landLordInfo: ret.data.landLordInfo });
        }

        await refreshAccountBalance(store);

        ga.gaEvent('event', 'connectWallet', {
            'event_label': wallet
        });
    }
    else {
        localStorage.removeItem('wallet');
        store.commit('clearAccount');
    }
    return account;
}

export const disconnectWallet = (store) => {
    localStorage.removeItem('wallet');
    store.commit('clearAccount');
}

export const refreshAccountBalance = async (store) => {
    let account = store.state.account.wallet;
    let token = store.state.account.token;
    if (account == null) {
        return;
    }
    if (token.token_symbol == 'ETH') {
        let balance = await web3.eth.getBalance(account.address);
        store.commit('setBalance', ETH(balance));
    }
    else {
        const SRC_TOKEN_CONTRACT = new web3.eth.Contract(ERC20_ABI, token.token_address);
        store.commit('setBalance', ETH(await SRC_TOKEN_CONTRACT.methods.balanceOf(account.address).call()));
    }
}